import React from "react";

export default function Conclusion() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-6xl py-16 px-4 sm:px-6">
        <div className="flex flex-col xl-custom:flex-row gap-12 xl-custom:items-start items-center">
          
          <div className="w-full xl-custom:w-1/2 order-1 xl-custom:order-1">
            <h2 
              className="
                w-full text-black mb-6
                font-uber text-[28px] font-bold leading-[36px] text-current
                sm:text-[32px] sm:leading-[40px]
                xl-custom:text-[36px] xl-custom:leading-[44px]
                transition duration-200 ease-in-out
              "
            >
              Conclusion
            </h2>
            <p 
              className="
                text-black
                font-uber text-base font-normal leading-normal
              "
            >
              The adoption of playables has transformed how brands engage with their audience. By integrating Playable Ads, brands unlock next-level engagement and conversions, reshaping digital marketing for the future. Moving forward, we aim to refine these strategies further, ensuring that interactive digital experiences continue to evolve and resonate with customers.
            </p>
          </div>
          
          <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-2">
            <div className="w-full h-80 flex items-center justify-center rounded-lg">
              <img
              src="/uploads/CaseStudy/Asset 96.webp"
              className="w-full h-full object-cover rounded-lg" alt="Conclusion visual placeholder" />
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}